import { render } from "./DataViewLayoutOptions.vue?vue&type=template&id=7e0348d8"
import script from "./DataViewLayoutOptions.vue?vue&type=script&lang=js"
export * from "./DataViewLayoutOptions.vue?vue&type=script&lang=js"
script.render = render

export default script